import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectId } from 'api/models';
import { Task, TaskCreationRequest, TasksStore } from './store';

export const tasksSlice = createSlice({
  name: '@@TASKS',
  initialState: TasksStore.empty(),

  reducers: (create) => ({
    empty: create.reducer(() => TasksStore.empty()),
    add: create.reducer(
      (state: TasksStore, { payload: task }: PayloadAction<Task>) =>
        TasksStore.add(task)(state),
    ),

    creating: create.reducer(
      (
        state: TasksStore,
        { payload: [task, id] }: PayloadAction<[TaskCreationRequest, string]>,
      ) => TasksStore.creating(task, id)(state),
    ),

    created: create.reducer(
      (
        state: TasksStore,
        { payload: [task, id] }: PayloadAction<[Task, string]>,
      ) => TasksStore.created(task, id)(state),
    ),

    failed: create.reducer(
      (state: TasksStore, { payload: id }: PayloadAction<string>) =>
        TasksStore.failed(id)(state),
    ),

    loadingProjectTasks: create.reducer(
      (state: TasksStore, { payload: projectId }: PayloadAction<ProjectId>) =>
        TasksStore.loadingProjectTasks(projectId)(state),
    ),

    loadedProjectTasks: create.reducer(
      (
        state: TasksStore,
        { payload: [projectId, tasks] }: PayloadAction<[ProjectId, Task[]]>,
      ) => TasksStore.loadedProjectTasks(projectId, tasks)(state),
    ),

    loadedAllTasks: create.reducer(
      (state: TasksStore, { payload: tasks }: PayloadAction<Task[]>) =>
        TasksStore.loadedAllTasks(tasks)(state),
    ),

    updating: create.reducer(
      (state: TasksStore, { payload: tasks }: PayloadAction<Task[]>) =>
        TasksStore.updating(tasks)(state),
    ),

    updated: create.reducer(
      (state: TasksStore, { payload: tasks }: PayloadAction<Task[]>) =>
        TasksStore.updated(tasks)(state),
    ),

    revert: create.reducer(
      (state: TasksStore, { payload: taskIds }: PayloadAction<number[]>) =>
        TasksStore.revert(taskIds)(state),
    ),

    deleting: create.reducer(
      (state: TasksStore, { payload: tasks }: PayloadAction<Task[]>) =>
        TasksStore.deleting(tasks)(state),
    ),

    deleted: create.reducer(
      (
        state: TasksStore,
        { payload: tasks }: PayloadAction<Pick<Task, 'taskId'>[]>,
      ) => TasksStore.deleted(tasks.map((x) => x.taskId))(state),
    ),

    restored: create.reducer(
      (
        state: TasksStore,
        { payload: tasks }: PayloadAction<Pick<Task, 'taskId'>[]>,
      ) => TasksStore.restored(tasks.map((x) => x.taskId))(state),
    ),
  }),
});
